import { FilterFields, useLazyFetchProductsJsonQuery } from "../../../../Domains/Products/api/productJsonApi.ts";
import { Controller, ControllerProps } from "react-hook-form";
import FormFieldTwoColumns from "../Forms/Layouts/FormFieldTwoColumns.tsx";
import { RenderOption } from "../../views/OptionGroups/Tabs/AutocompleteProductRenderOption.tsx";
import React from "react";
import { AutocompleteItemableProps } from "@jamezz/react-components";
import { AutocompleteProduct } from "@jamezz/react-components";

export function FormAutocomplete<Multiple extends boolean>({
  tKey,
  tDefault,
  name,
  autcompleteProps,
  value,
  onChange,
}: {
  tKey: string;
  tDefault: string;
  name: string;
  autcompleteProps: Partial<AutocompleteItemableProps<any, Multiple, false, FilterFields>>;
  value: (
    field: Parameters<ControllerProps["render"]>[0]["field"]
  ) => AutocompleteItemableProps<any, Multiple, false, FilterFields>["value"];
  onChange: (
    field: Parameters<ControllerProps["render"]>[0]["field"]
  ) => AutocompleteItemableProps<any, Multiple, false, FilterFields>["onChange"];
}) {
  const { ...otherProps } = autcompleteProps;

  return (
    <FormFieldTwoColumns tKey={tKey} tDefault={tDefault}>
      <Controller
        name={name}
        render={({ field }) => {
          return (
            <AutocompleteProduct
              inputFieldProps={{ sx: { minWidth: 400 } }}
              multiple={true}
              defaultFilters={{
                vestiging_id: { field: "vestiging_id", operator: "=", value: autcompleteProps.menuSalesareaId },
                is_option: { field: "is_option", value: false },
              }}
              menuSalesareaId={autcompleteProps.menuSalesareaId}
              fetchQuery={useLazyFetchProductsJsonQuery}
              renderOption={(props, option) => <RenderOption option={option} />}
              {...otherProps}
              value={value?.(field) ?? JSON.parse(field.value ?? "[]")}
              onChange={
                onChange?.(field) ??
                ((value) => {
                  field.onChange(JSON.stringify((value ?? []).map((item) => item.id)));
                })
              }
            />
          );
        }}
      />
    </FormFieldTwoColumns>
  );
}
